import { useQuery } from '@tanstack/react-query';
import { fetchLocalContentGenres } from './apiFetchLocalContentGenres';
import { GlobalReactQueryOptions } from '../../../../config';

export const useLocalContentGenres = (shopLanguage: string | undefined) => {
    const genres = useQuery(['localContentGenres', shopLanguage], () => fetchLocalContentGenres(shopLanguage), {
        ...GlobalReactQueryOptions
    });

    return {
        ...genres,
        localContentGenres: genres.data?.localContentGenres ?? [],
        standardGenres: genres.data?.standardGenres ?? [],
        defaultGenre: genres.data?.localContentGenres?.[0]?.id ?? genres.data?.standardGenres?.[0]?.id
    };
};
